import React from 'react';
import './hire.css';
import { FaTimes, FaGoogleDrive, FaEnvelope, FaFolderOpen } from 'react-icons/fa';

const NotesModal = ({ isOpen, onClose }) => {
  const DRIVE_FOLDER_LINK = 'https://drive.google.com/drive/folders/1HW4KKo8NbW3L3zgJTrjSWDVS42JN5bb1?usp=sharing';

  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}></div>
      
      <div className="notes-modal">
        <div className="modal-header">
          <div className="header-content">
            <FaGoogleDrive className="drive-main-icon" />
            <h2>Academic Resource Portal</h2>
            <p>You can get notes on Google Drive</p>
          </div>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-content">
          <div className="drive-access-card">
            <div className="card-header">
              <FaFolderOpen className="folder-icon" />
              <h3>Main Resource Repository</h3>
            </div>
            <p className="card-description">
              Access organized course materials, lecture notes, and research documents
            </p>
            <a
              href={DRIVE_FOLDER_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="drive-access-button"
            >
              <FaGoogleDrive className="button-icon" />
              Access Drive
            </a>
          </div>

 

          <div className="support-section">
            <div className="support-content">
              <FaEnvelope className="support-icon" />
              <div>
                <h4>Access Support</h4>
                <p>Contact: sanojshrestha2000@gmail.com</p>
                <p>Response time: Typically within 24 hours</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotesModal;